import emojiSprite from "../../assets/sheet_facebook_32.png";
import {emojiMap} from "../moodPack/emoji/emojiMap";

const SPRITE_COLS = 62;

export function renderMessage(text, size = 23) {
    if (!text) return null;

    text = String(text || "");

    const result = [];
    let lastIndex = 0;

    const regex = /([\u{1F1E6}-\u{1F1FF}]{2})|((?:\p{Extended_Pictographic}|\p{Emoji_Presentation})\uFE0F?)/gu;

    for (const match of text.matchAll(regex)) {
        const emojiChar = match[0];
        const index = match.index;
        const unified = Array.from(emojiChar)
            .map(c => c.codePointAt(0).toString(16))
            .join("-");

        const emoji = Object.values(emojiMap).find(
            (e) => (e.unified?.toLowerCase() === unified)
        );

        if (!emoji) continue;

        if (index > lastIndex) {
            result.push(text.slice(lastIndex, index));
        }

        const backgroundSize = `${SPRITE_COLS * 100}% auto`;
        const backgroundPosition = `${(emoji.x / (SPRITE_COLS - 1)) * 100}% ${(emoji.y / (SPRITE_COLS - 1)) * 100}%`;

        result.push(
            <span
                key={index}
                style={{
                    display: "inline-block",
                    width: size,
                    height: size,
                    backgroundImage: `url(${emojiSprite})`,
                    backgroundSize,
                    backgroundPosition,
                    backgroundRepeat: "no-repeat",
                    verticalAlign: "top",
                }}
            />
        );

        lastIndex = index + emojiChar.length;
    }

    if (lastIndex < text.length) {
        result.push(text.slice(lastIndex));
    }

    return result?.[0];
}
